import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    width: 250,
    flex: "1 1 auto",
    maxHeight: 300,
    padding: 10,
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    overflowY: "auto"
  },
  emoji: {
    paddingLeft: 4,
    paddingRight: 4,
    cursor: "pointer",
    "&:hover": {
      background:
        theme.palette.type === "dark"
          ? "rgba(255, 255, 255, 0.22)"
          : "rgba(0, 0, 0, 0.22)"
    }
  }
}));
